import getYoutubeId from "~/lib/utils/getYoutubeId";

export default function getYoutubeThumbnail(url: string): string {
  return `https://img.youtube.com/vi/${getYoutubeId(url)}/hqdefault.jpg`;
}
